import React from "react";

// Components
import { ContactDetail } from "shared/components/user";
import Overlay from "shared/components/overlay/Overlay";
import SlidingPanel from "shared/components/sliding-panel/SlidingPanel";

// Styles
import styles from './ContactDetail.module.scss';

const ContactDetailPanel = ({ contact='', isActive=false, afterSaveContact, onClose }) => {
    return (
        <div className={ styles.wrapper }>
            <SlidingPanel className={ styles.panel } isActive={ isActive }>
                { contact &&
                    <ContactDetail
                        onClose={ onClose }
                        contact={ contact }
                        afterSaveContact={ afterSaveContact } />
                }
            </SlidingPanel>

            <Overlay isActive={ isActive } isContained onClick={ onClose } />
        </div>
    )
}

export default ContactDetailPanel;
